import { render, staticRenderFns } from "./AccountTransportLayout.vue?vue&type=template&id=19ebcc24&scoped=true&"
import script from "./AccountTransportLayout.vue?vue&type=script&lang=js&"
export * from "./AccountTransportLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccountTransportLayout.vue?vue&type=style&index=0&id=19ebcc24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ebcc24",
  null
  
)

component.options.__file = "AccountTransportLayout.vue"
export default component.exports